import React, { useState, useEffect } from "react";
import { Box, Paper, Typography, Button } from "@mui/material";

import AgentsList from "../components/AgentsList";
import AgentForm from "../components/AgentForm";
import ChatView from "../components/ChatView";

// Quitar selectedAgent y onNavigate de las props
function AgentsTab({ agents, fetchAgents }) {
  // Restaurar estado local para el agente seleccionado
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [isAgentLoading, setIsAgentLoading] = useState(false);
  const [view, setView] = useState("form");

  // Ya no necesitamos este useEffect basado en props
  /*
  useEffect(() => {
    setIsAgentLoading(false); 
    setView("form"); 
    if (!selectedAgent) {
       setIsAgentLoading(false);
    }
  }, [selectedAgent]);
  */

  // Restaurar handlers originales con setTimeout y setSelectedAgent local
  const handleSelectAgent = (agent) => {
    if (agent?.id !== selectedAgent?.id) {
      setIsAgentLoading(true);
      setTimeout(() => {
        setSelectedAgent(agent);
        // El loading se quitará cuando AgentForm llame a onFormReady
        setView("form"); // Asegurar vista form después de cargar
      }, 800); // Mantener el delay configurado
    } else {
      // Si es el mismo agente, solo asegurar vista form
      setView("form");
    }
  };

  const handleCreateNewAgent = () => {
    if (selectedAgent !== null) {
      setIsAgentLoading(true);
      setTimeout(() => {
        setSelectedAgent(null);
        setView("form");
      }, 800); 
    } else {
      setSelectedAgent(null);
      setView("form");
    }
  };

  // Callback onFormReady (se mantiene igual)
  const handleFormReady = () => {
    setIsAgentLoading(false);
  };

  // toggleView (se mantiene igual)
  const toggleView = () => {
    setView((prev) => (prev === "form" ? "chat" : "form"));
  };

  return (
    <Box sx={{ display: "flex", gap: 2 }}>
      {/* Lista de Agentes */}
      <AgentsList
        agents={agents}
        onSelectAgent={handleSelectAgent}
        onCreateNew={handleCreateNewAgent}
        // Usar el ID del estado local selectedAgent para el highlight
        selectedAgentId={selectedAgent?.id || selectedAgent?.agent_id} 
      />

      {/* Panel Derecho: formulario o chat */}
      <Box sx={{ flexGrow: 1, position: 'relative' }}>
        <Paper sx={{ p: 3, position: 'relative' }}> 
          
          {/* Ya no necesitamos el overlay aquí, AgentForm lo tiene */}

          {selectedAgent ? (
            <Typography variant="h5" gutterBottom>
              Editando: {selectedAgent.agent_id}
            </Typography>
          ) : (
            <Typography variant="h5" gutterBottom>
              Creando nuevo Agente
            </Typography>
          )}

          {selectedAgent && (
            // Volver a deshabilitar el botón basado en el loading local
            <Button variant="outlined" onClick={toggleView} sx={{ mb: 2 }} disabled={isAgentLoading} >
              {view === "form" ? "Probar Chat" : "Volver a Config"}
            </Button>
          )}

          {view === "form" && (
            <AgentForm
              agent={selectedAgent} // Pasar el agente del estado local
              fetchAgents={fetchAgents}
              isAgentLoading={isAgentLoading} // Pasar el estado de carga local
              onFormReady={handleFormReady} // Pasar el callback 
              onSaved={(updatedAgent) => {
                // Actualizar el estado local al guardar
                setSelectedAgent(updatedAgent); 
              }}
            />
          )}

          {view === "chat" && selectedAgent && (
            <ChatView 
              agentId={selectedAgent.agent_id} 
              agentPrompt={selectedAgent.prompt} 
            />
          )}
        </Paper>
      </Box>
    </Box>
  );
}

export default AgentsTab;
